var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-contact-list',{attrs:{"object":Number(_vm.$route.params.id),"object-type":_vm.OBJECT_TYPE_COMPANY,"c-permission-e":_vm.C_COMPANY_CONTACTS_E,"c-permission-v":_vm.C_COMPANY_CONTACTS_V}})}
var staticRenderFns = []

export { render, staticRenderFns }